// src/components/PageHead.jsx
//
// The eyebrow / title / subtitle / actions block at the top of a portal page.
//
// WHY
// ---
// Six patient-portal pages each built this inline, and no two agreed:
//
//   My Care Plan      gold eyebrow, 24px title, 14px sub, centred column
//   My Health Story   gold eyebrow, 24px title, 14px sub, centred column
//   My Documents      no eyebrow,   22px title, 13px sub, centred column
//   My Lab Tests      no eyebrow,   24px title, 14px sub, FULL BLEED
//   My Appointments   no eyebrow,   24px title, 14px sub, FULL BLEED
//   Care Team         no head at all
//
// A new patient meets all of them in their first session, so the drift is not
// theoretical — the title moves and changes size as they use the sidebar. The
// full-bleed pages are the visible half of it: their heading starts at a
// different x than the pages that centre a 680px column.
//
// Styles live in .page-head* in index.css. `actions` is a slot rather than a
// button prop because the pages that have one all want a real button with
// their own handler, and one of them may later want two.
import React from 'react';

export default function PageHead({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="page-head">
      <div className="page-head__text">
        {eyebrow && <div className="page-head__eyebrow">{eyebrow}</div>}
        <h1 className="page-head__title">{title}</h1>
        {subtitle && <p className="page-head__sub">{subtitle}</p>}
      </div>
      {actions && <div className="page-head__actions">{actions}</div>}
    </div>
  );
}
